import { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@mui/material';
import { initiateTransaction, updateTransaction } from 'lib/axiosUtils';
import { TRANSACTION_NOTE, SUBSCRIPTION_NOTE } from 'assets/constants/Constants';
import { updateUserSessionData } from 'lib/utils';

const PaymentPage = (props) => {
    const history = useHistory();
    const redirectedFrom = history.location.state?.redirectedFrom;
    const creditAmount = props?.location.state?.data?.credits;
    const subscription = props?.location.state?.data?.subscriptionId;
    const userDataFromDatabase = JSON.parse(localStorage.getItem('userData'));
    const [userEmail] = useState(userDataFromDatabase?.email_id);
    const [userPhoneNumber, setUserPhoneNumber] = useState(userDataFromDatabase?.phone_number ? userDataFromDatabase?.phone_number : '');
    const [amount, setAmount] = useState(props.location.state ? props.location.state.data?.price : '');
    const [currency] = useState('INR');
    // const [isPaymentInProgress, setIsPaymentInProgress] = useState(false);
    const [documentIdOfCurrentPaymentTransaction, setDocumentIdOfCurrentPaymentTransaction] = useState(null);

    const razorpayCheckoutResponseHandler = useCallback(async (response, documentId, didUserCloseRazorpayCheckout = false) => {
        if ( !response?.razorpay_payment_id ) {
            alert('Payment failed. Please try again.');
        } else {
        const body = {
            documentIdOfCurrentPaymentTransaction: documentId
        };

        if (response?.razorpay_payment_id) {
            body.orderId = response?.razorpay_order_id;
            body.paymentId = response?.razorpay_payment_id;
            body.razorpaySignature = response?.razorpay_signature;

            console.log("redirectedFrom::", redirectedFrom);

            if(redirectedFrom === 'CreditUsagePage'){
                body.shouldTopupCredit = true;
                body.transactionNote = TRANSACTION_NOTE;
            }else if(redirectedFrom === 'BuySubscription'){
                body.shouldBuySubscription = true;
                body.userReferredCode = userDataFromDatabase?.referred_code;
                body.transactionNote = SUBSCRIPTION_NOTE;
                body.userCredit = creditAmount;
                body.userSubscription = subscription;
            }
        }
        else if (didUserCloseRazorpayCheckout) {
            body.didUserCloseRazorpayCheckout = didUserCloseRazorpayCheckout;
        }

        const updatePaymentResponse = await updateTransaction({}, body);

        if (updatePaymentResponse?.statusCode === 200) {
            alert('Payment successfull.');
            await updateUserSessionData(userDataFromDatabase);
            
            if(redirectedFrom === 'CreditUsagePage')
            {
                if (window.location.pathname === '/credit-usage') {
                  window.location.reload(); // refresh the same page
                } else {
                  window.location.href = '/credit-usage'; // go to page & reload
                }
            } else if (redirectedFrom === 'BuySubscription'){
                if (window.location.pathname === '/subscription') {
                    window.location.reload(); // refresh the same page
                  } else {
                    window.location.href = '/subscription'; // go to page & reload
                  }
            }
            else {
                history.push({ pathname: '/payment/transactions' });
            }
        }}
    },[creditAmount,history,redirectedFrom,subscription,userDataFromDatabase]);
    
    useEffect(() => {
        window.onRazorpayCheckoutResponse = (response) => razorpayCheckoutResponseHandler(response, documentIdOfCurrentPaymentTransaction);
        window.onRazorpayCheckoutClose = () => handleRazorpayCheckoutClose(documentIdOfCurrentPaymentTransaction);
        constructAndAppendRazorpayCheckoutScriptElement();
    }, [documentIdOfCurrentPaymentTransaction,razorpayCheckoutResponseHandler]);

    const constructAndAppendRazorpayCheckoutScriptElement = () => {
        const razorpayCheckoutScriptContainer = document.getElementById('razorpay-checkout-script-container');
        const razorpayCheckoutScript = document.createElement("script");
        razorpayCheckoutScript.id = 'razorpay-checkout-script';
        razorpayCheckoutScript.src = 'https://checkout.razorpay.com/v1/checkout.js';
        razorpayCheckoutScriptContainer.appendChild(razorpayCheckoutScript);
        razorpayCheckoutScript.onload = () => {
            console.log('Razorpay checkout script is loaded successfully.');
        }
    }

    const validatePaymentForm = () => {
        const isPhoneNumberValid = /[4-9]{1}[0-9]{9}/.test(userPhoneNumber) ? true : false;
        const isAmountValid = /[1-9]{1}[0-9]*/.test(amount) ? true : false;

        if (!isPhoneNumberValid) {
            alert('Please enter a valid Indian phone number.');
        }
        if (!isAmountValid) {
            alert('Please enter a valid amount.');
        }
        return isPhoneNumberValid && isAmountValid;
    };

    const initiatePayment = async () => {
        const body = {
            userId: userDataFromDatabase?._id,
            email: userEmail,
            phoneNumber: `+91${userPhoneNumber}`,
            amount: amount,
            currency: currency
        };
        return await initiateTransaction({}, body);
    }

    const invokePaymentGateway = (paymentDetails) => {
        const orderDetails = JSON.parse(paymentDetails?.raw_payment_details);
        const razorpayCheckoutScriptContainer = document.getElementById('razorpay-checkout-script-container');
        const razorpayCheckoutInvokerScript = document.createElement("script");
        razorpayCheckoutInvokerScript.id = 'razorpay-checkout-invoker';
    
        razorpayCheckoutInvokerScript.textContent = `var options = {
            "key": "rzp_test_RLjgtAspFkp1Hy",
            "amount": "${orderDetails.amount}", // optional 
            "currency": "${orderDetails.currency}",
            "name": "Million AI Portal", // client specific
            "description": "Test Payment",
            "image": "", //client specific
            "order_id": "${orderDetails.id}", //must
            "handler": function (response){
                window.onRazorpayCheckoutResponse(response);
            },
            "prefill": {
                "email": "${userEmail}", 
                "contact": "${userPhoneNumber}",
            },
            "notes": {},
            "theme": {
                "color": "",
            },
            "config": {
                "display": {
                    "language": ""
                }
            },
            "timeout": "360",
            "method": {
                "netbanking": true,
                "card": true,
                "upi": true,
                "wallet": false,
                "emi": false,
                "paylater": false,
            },
            "modal": {
                "ondismiss": function(){
                    window.onRazorpayCheckoutClose();
                },
            }
        };
        var rzp1 = new Razorpay(options);
        rzp1.on('payment.failed', function (response){
            window.onRazorpayCheckoutResponse(response);
        });
        rzp1.open();`;
    
        razorpayCheckoutScriptContainer.appendChild(razorpayCheckoutInvokerScript);
        return;
    }

    const payButtonHandler = async () => {
        if ( !validatePaymentForm() ) { return; };

        // setIsPaymentInProgress(true);

        const initiatePaymentResponse = await initiatePayment();

        if ( (initiatePaymentResponse?.statusCode === 200) && initiatePaymentResponse?.data?.result?._id ) {
            setDocumentIdOfCurrentPaymentTransaction(initiatePaymentResponse?.data?.result?._id);
            invokePaymentGateway(initiatePaymentResponse?.data?.result);
        }
    };

    const handleRazorpayCheckoutClose = async (documentId) => {
        const body = {
            documentIdOfCurrentPaymentTransaction: documentId,
            didUserCloseRazorpayCheckout: true
        };

        const updatePaymentResponse = await updateTransaction({}, body);

        if (updatePaymentResponse?.statusCode === 200) {
            console.log('Update payment transaction for cancelled transaction: ', updatePaymentResponse);
        }

        alert('Payment Cancelled. Please try again.');
    }

    const changeAmount = (value) => {
        const regularExpression = /^[0-9\b]+$/;
        if (value === '' || regularExpression.test(value)) {
            setAmount(value);
        }
    }

    return (
        <div id='payment-page'>
            <div className='main-content'>
                <form id='payment-form' onSubmit={(event) => { event.preventDefault(); }}>
                    <div className='form-row' style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                        <div className=''>
                            <label className='form-label' style={{width: 140, marginBottom: 20}}>Email: <span className="text-danger">*</span></label>
                            <input className='form-input' value={userEmail} onChange={() => {}} placeholder='Enter Email' style={{width: 250}}/>
                        </div>
                        <div className=''>
                            <label className='form-label' style={{width: 140, marginBottom: 20}}>Phone Number: <span className="text-danger">*</span></label>
                            <input className='form-input' value={userPhoneNumber} onChange={(event) => setUserPhoneNumber(event.target.value)} placeholder='Enter Phone Number' style={{width: 250}}/>
                        </div>
                    </div>
                    <div className='form-row' style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                        <div className=''>
                            <label className='form-label' style={{width: 140, marginBottom: 20}}>Amount: <span className="text-danger">*</span></label>
                            <input className='form-input' inputMode="numeric" pattern="[0-9]*" value={amount} onChange={(event) => changeAmount(event.target.value)} placeholder='Enter Amount' style={{width: 250}}/>
                        </div>
                        <div className=''>
                            <label className='form-label' style={{width: 140, marginBottom: 20}}>Currency: <span className="text-danger">*</span></label>
                            <input className='form-input' value={currency} onChange={() => {}} placeholder='Select Currency' disabled style={{width: 250}}/>
                        </div>
                    </div>
                    <div className='form-button-wrapper' style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20}}>
                        <Button id='pay-button' variant='contained' onClick={payButtonHandler}>Pay</Button>
                    </div>
                </form>
                <div id='razorpay-checkout-script-container'></div>
            </div>
        </div>
    );
};

export default PaymentPage;